import React, { useState, useEffect } from 'react';
import Logo from './Logo';
import { getAuthedUser, getRegisteredUser } from '../services/authStorage';
import './UserProfile.css';

const SYSTEM_CONTACT_PHONE = '400-660-8948';
const SYSTEM_CONTACT_EMAIL = 'xcgroup@xcect.com';

const maskPhone = (phone) => {
  const normalized = String(phone || '').replace(/\s+/g, '');
  if (normalized.length < 7) return '--';
  return `${normalized.slice(0, 3)}****${normalized.slice(-4)}`;
};

const maskIdCard = (idCard) => {
  const normalized = String(idCard || '').replace(/\s+/g, '');
  if (normalized.length < 8) return '--';
  return `${normalized.slice(0, 3)}***********${normalized.slice(-4)}`;
};

const formatTime = (value) => {
  if (!value) return '--';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '--';
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const UserProfile = ({
  onClose,
  userInfo,
  initialShowContactInfo = false,
  contactOnly = false,
  onLogout
}) => {
  const currentUser = userInfo || getAuthedUser() || getRegisteredUser();
  const [showContactInfo, setShowContactInfo] = useState(initialShowContactInfo);

  useEffect(() => {
    setShowContactInfo(initialShowContactInfo);
  }, [initialShowContactInfo]);

  return (
    <div className="user-profile-overlay" onClick={onClose}>
      <div className="user-profile-modal" onClick={(e) => e.stopPropagation()}>
        <div className="user-profile-header">
          <div className="user-profile-header-content">
            <Logo size={24} className="user-profile-logo" />
            <h3>{contactOnly ? '联系我们' : '我的信息'}</h3>
          </div>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="user-profile-content">
          {!contactOnly && (
            <>
              <div className="info-item">
                <div className="info-label">注册手机号</div>
                <div className="info-value">{maskPhone(currentUser?.phone)}</div>
              </div>
              
              <div className="info-item">
                <div className="info-label">身份证号</div>
                <div className="info-value">{maskIdCard(currentUser?.idCard)}</div>
              </div>

              <div className="info-item">
                <div className="info-label">注册时间</div>
                <div className="info-value">{formatTime(currentUser?.registeredAt)}</div>
              </div>
            </>
          )}

          {contactOnly && (
            <div className="contact-details">
              <div className="info-item">
                <div className="info-label">联系电话</div>
                <div className="info-value">{SYSTEM_CONTACT_PHONE}</div>
              </div>

              <div className="info-item">
                <div className="info-label">联系邮箱</div>
                <div className="info-value">{SYSTEM_CONTACT_EMAIL}</div>
              </div>
            </div>
          )}
        </div>

        {!contactOnly && onLogout && (
          <div className="user-profile-footer">
            <button className="logout-button" onClick={onLogout}>
              退出登录
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
